export default __webpack_public_path__ + "static/media/delete.56a21787.svg";